module.exports = "<h1>Frequently Asked Questions</h1>\r\n<br>\r\n<app-how></app-how>\r\n"